/* Scoped interactions for the GoodDose hair-care page. */
(() => {
  const registry = new Map(window.HL?.q || []), active = new Map();
  const isReferenceDestination = (value) => {
    try {
      const url = new URL(value, location.href);
      if (url.protocol === 'mailto:') return url.pathname !== 'support@gooddoserx.com';
      if (url.origin === 'https://www.legitscript.com' && url.pathname === '/websites/' && url.search === '?checker_keywords=gooddoserx.com') return false;
      if (url.origin === 'https://intake.gooddoserx.com' && url.pathname === '/f/hair-loss' && !url.search) return false;
      if (url.origin !== location.origin) return true;
      if (url.pathname === location.pathname && url.hash) return false;
      return !['/', '/pages/contact', '/policies/privacy-policy', '/policies/refund-policy', '/policies/terms-of-service', '/policies/contact-information', '/search'].includes(url.pathname);
    } catch { return true; }
  };
  const navigate = (url) => { if (!isReferenceDestination(url)) location.href = url; };
  const init = (id) => {
    const root = document.getElementById('shopify-section-' + id);
    const callback = registry.get(id);
    if (!root || !callback) return;
    active.get(id)?.abort();
    root.querySelectorAll('.swiper').forEach(el => el.swiper?.destroy(true, true));
    const abort = new AbortController(); active.set(id, abort);
    const scoped = new Proxy(document, {get(target, key) {
      if (key === 'querySelector') return (selector) => root.matches(selector) ? root : root.querySelector(selector);
      if (key === 'querySelectorAll') return (selector) => root.querySelectorAll(selector);
      if (key === 'getElementById') return (id) => root.querySelector('#' + CSS.escape(id));
      if (key === 'addEventListener') return (event, fn, options) => event === 'DOMContentLoaded' ? fn() : target.addEventListener(event, fn, {...(typeof options === 'object' ? options : {}), signal: abort.signal});
      const value = target[key]; return typeof value === 'function' ? value.bind(target) : value;
    }});
    function SectionSwiper(selector, options = {}) {
      const target = typeof selector === 'string' ? root.querySelector(selector) : selector;
      if (!target) return null;
      for (const group of ['navigation','pagination']) if (options[group]) {
        for (const field of ['nextEl','prevEl','el']) if (typeof options[group][field] === 'string') options[group][field] = root.querySelector(options[group][field]);
      }
      return new window.Swiper(target, options);
    }
    callback(scoped, SectionSwiper);
  };
  window.HL = {navigate, register(id, callback) {
    registry.set(id, callback);
    if (document.readyState !== 'loading') init(id);
  }};
  document.addEventListener('DOMContentLoaded', () => {
    for (const id of registry.keys()) init(id);
    document.querySelectorAll('[data-bg]').forEach(el => el.style.backgroundImage = `url("${el.dataset.bg}")`);
  });
  document.addEventListener('shopify:section:load', event => {
    const root = event.target;
    // Shopify inserts section scripts inertly. Recreate only our trusted local
    // registration script, then initialize within this section's DOM scope.
    root.querySelectorAll('script').forEach(old => {
      if (old.textContent.trim().startsWith('window.HL.register(')) {
        const script = document.createElement('script');script.textContent=old.textContent;old.replaceWith(script);
      }
    });
  });
  document.addEventListener('shopify:section:unload',event=>{active.get(event.detail.sectionId)?.abort();if(event.target.querySelector('.drawer.active'))document.body.style.overflow='';});
  document.addEventListener('shopify:block:select',event=>{
    const slide=event.target.closest('.swiper-slide');if(slide){const parent=slide.closest('.swiper');parent?.swiper?.slideTo(Array.from(slide.parentNode.children).filter(el => el.classList.contains('swiper-slide')).indexOf(slide));}
  });
  document.addEventListener('click',event=>{
    const link=event.target.closest('a[href]');if(link&&isReferenceDestination(link.href))event.preventDefault();
  },true);
  document.addEventListener('submit', event => {
    if (isReferenceDestination(event.target.action)) event.preventDefault();
  }, true);
})();
